import { netsparkAxios } from 'core/services/HTTPService';
import { IEngagementsTotalItem } from 'pages/Dashboard/Dashboard.models';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';
import { getEngagementsRenewalOrdersUrl } from 'pages/Dashboard/api/apiUrls';

const getEngagementsRenewalOrders = (
  signal, params: TPeriod,
) => netsparkAxios
  .get<IEngagementsTotalItem[]>(getEngagementsRenewalOrdersUrl, { signal, params });

export default getEngagementsRenewalOrders;
